// This is used here in peregrine and in the storefront.
export const CACHE_PERSIST_PREFIX = "apollo-cache-persist";
